import './styles/graphic.scss';
import * as d3 from 'd3';


export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    margins,
    // height
  } = props;

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const w = initialWidth - margins.left - margins.right;
  const h = initialHeight - margins.top - margins.bottom;

  d3.timeFormatDefaultLocale({
    periods: ['a.m.', 'p.m.'],
    shortDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
  });

  d3.json('https://ix.cnn.io/data/novel-coronavirus-2019-ncov/us/historical.min.json', { crossOrigin: 'anonymous' })
    .then((data) => {
      const rawData = data.data.filter(d => d.usps == 'US')[0].data;
      const timeStamp = data.lastUpdatedStr;

      rawData.forEach((d, i) => {
        d.date = d3.timeParse('%Y-%m-%d')(d.date);
        d.deaths = +d.deaths;
        d.cases = +d.cases;
        if (i > 0) {
          d.newDeaths = d.deaths - rawData[i - 1].deaths;
        } else {
          d.newDeaths = d.deaths;
        }
        if (i > 7) {
          const slice = rawData.slice(i - 6, i + 1);
          const vals = slice.map(d => d.newDeaths);
          const avg = vals.reduce((acc, cur) => acc + cur, 0) / 7;
          d.movingAvg = avg;
        }
      });

      data = rawData.filter(d => d.date >= d3.timeParse('%Y-%m-%d')('2020-03-01'));

      drawChart(data);
      updateTimeStamp(timeStamp);
    });


  const updateTimeStamp = function (timeStamp) {
    const el = document.getElementById('timestamp');
    el.innerText = `Last updated: ${timeStamp}`;
  };


  const drawChart = function (data) {
    const barSpacing = 1;
    const barWidth = w / data.length - 1;

    const xScale = d3.scaleTime()
      .domain(d3.extent(data, d => d.date))
      .range([barWidth / 2, w - barWidth / 2]);

    const yScale = d3.scaleLinear()
      .domain([0, d3.max(data, d => d.newDeaths)])
      .range([h, 0]);

    // console.log(data);

    // AXES
    const monthOffset = d3.timeMonth.offset(data[data.length - 1].date, 0);
    const yearOffset = d3.timeYear.offset(data[data.length - 1].date, 0);

    const formatTime = d3.timeFormat('%b');
    const xAxis = svg.append('g')
      .attr('class', 'axis xaxis')
      .attr('transform', `translate(${[margins.left, h + margins.top]})`)
      .call(d3.axisBottom(xScale)
        .tickValues(d3.timeMonths(data[0].date, monthOffset))
        .tickSize(10)

        .tickFormat((d, i) => {
          if (i == 0) {
            return d3.timeFormat('%b %Y')(d);
          } if (d3.timeYear(d) >= d) {
            return d3.timeFormat('%b %Y')(d);
          }
          return '';
        }));

    xAxis.select('text').classed('first', true);

    xAxis.selectAll('text')
      .attr('dy', '1em');

    const xAxisYears = svg.append('g')
      .attr('class', 'axis xaxis years')
      .attr('transform', `translate(${[margins.left, h + margins.top]})`)
      .call(d3.axisBottom(xScale)
        .tickValues(d3.timeYears(data[0].date, yearOffset))
        .tickSize(10)

        .tickFormat(''));


    const yAxis = svg.append('g')
      .attr('class', 'axis yaxis')
      .attr('transform', `translate(${[w + margins.left, margins.top]})`)
      .call(d3.axisLeft(yScale)
        .tickSize(w)
        .ticks(5));

    yAxis.select('.domain').remove();

    // BARS
    /*
    const bars = svg.append('g')
      .attr('class', 'bars')
      .selectAll('rect')
      .data(data)
      .enter()
      .append('rect')
      .attr('class', 'bar')
      .attr('transform', (d, i) => `translate(${[1 + margins.left + i * (barWidth + barSpacing), yScale(d.newDeaths) + margins.top]})`)
      .attr('width', barWidth)
      .attr('height', d => h - yScale(d.newDeaths));

    bars.attr('fill', '#e6e6e6');
    */

    // AVG LINE
    const line = d3.line()
      .x(d => xScale(d.date))
      .y(d => yScale(d.movingAvg));

    const avgLine = svg.append('g')
      .attr('class', 'avg-line')
      .attr('transform', `translate(${[margins.left, margins.top]})`)
      .append('path')
      .datum(data)
      .attr('fill', 'none')
      .attr('stroke', '#D75E00')
      .attr('stroke-opacity', '1')
      .attr('stroke-width', '3')
      .attr('stroke-dasharray', '4')
      .attr('d', line);
  };
}
